import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { DiscountsMajor, ChevronRightMinor } from '@shopify/polaris-icons'

interface Props {
  className?: string
}

const handleMemberBenefitClick = () => {
  window.open('https://gigsafe-member-perks.perkspulse.com', '_blank')
}

const GigSafeMemberBenefitPortalComponent = ({ className }: Props) => {
  return (
    <div
      css={[tw`bg-shades-0 rounded-2xl p-4 cursor-pointer`, className]}
      onClick={handleMemberBenefitClick}
      data-testid="shared-gigsafe-member-benefit-portal-card"
    >
      <div css={tw`flex items-start flex-col justify-between gap-4`}>
        <div css={tw`flex items-center gap-4`}>
          <div
            css={tw`w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0`}
          >
            <DiscountsMajor css={tw`w-6 h-6 fill-info-500`} />
          </div>
          <Typography variant="h4" css={tw`text-info-500`}>
            Explore GigSafe Member Benefit Portal
          </Typography>

          <div css={tw`ml-4`}>
            <ChevronRightMinor css={tw`w-5 h-5 fill-shades-300`} />
          </div>
        </div>

        <Typography variant="body1" css={tw`text-shades-400`}>
          Exclusive perks just for GigSafe members! We have partnered with great brands to help save
          you time and money.
        </Typography>
      </div>
    </div>
  )
}

export const GigSafeMemberBenefitPortal = memo(GigSafeMemberBenefitPortalComponent)
